import { render, staticRenderFns } from "./ActVersion.vue?vue&type=template&id=10512ab0&"
import script from "./ActVersion.vue?vue&type=script&lang=js&"
export * from "./ActVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports